export const translations = {
  en: {
    // Navigation
    home: 'Home',
    aboutUs: 'About Us',
    services: 'Services',
    products: 'Products',
    contactUs: 'Contact Us',
    
    // Home Section
    welcomeTo: 'Welcome to',
    honouredTech: 'HonouredTech LLC',
    welcomeSubtitle: 'Your Trusted Technology Partner',
    welcomeDescription: 'We provide innovative technology solutions to help your business grow and succeed in the digital age. With cutting-edge expertise and a commitment to excellence, we deliver results that matter.',
    
    // About Section
    whoWeAre: 'WHO WE ARE',
    buildingTomorrow: 'Building',
    tomorrows: "Tomorrow's",
    technologyToday: 'Technology Today',
    aboutText1: "At HonouredTech, we don’t just build software — we create meaningful digital experiences.Backed by our resource with over a decade of software development expertise, our solutions are shaped by fresh ideas, skilled local talent, and innovative thinking.",
    aboutText2: 'Our name reflects our values: “Technology with Honor.”We believe software should be engaging, purposeful, and impactful. Every project we deliver is thoughtfully crafted to stand out, inspire conversations, and connect people through technology.',
    learnOurStory: 'Learn Our Story',
    foundedWithVision: 'Founded with a vision',
    youngAndGrowing: "We're young & growing",
    
    // Partnership Section
    greatIdea: 'Have a great idea but unsure how to implement it?',
    partnerText: 'Partner with',
    visionText: "and let's turn your vision into a successful product",
    lets: "Let's",
    riseTogether: 'Rise Together',
    innovateTogether: 'Innovate Together',
    growTogether: 'Grow Together',
    startBuilding: "Let's Start Building",
    
    // Services Section
    ourServices: 'Our Services',
    servicesDescription: 'We offer a comprehensive range of technology services to meet your business needs.',
    webDevelopment: 'Web Development',
    webDevDesc: 'Custom web applications built with modern technologies and best practices.',
    mobileApps: 'Mobile Apps',
    mobileAppsDesc: 'Native and cross-platform mobile applications for iOS and Android.',
    digitalMarketing: 'Digital Marketing',
    digitalMarketingDesc: 'Strategic digital marketing solutions to grow your brand and reach your target audience.',
    productDevelopment:" Product Development",
    productDevelopmentDesc:"From ideation to launch, we help you bring your products to market with ease.",
    
    // Products Section
    ourProducts: 'Our Products',
    productsDescription: 'Discover our innovative solutions designed to transform your business.',
    recentlyLaunched: 'Recently Launched',
    nestAuraTab: 'NestAura Project',
    smartMaintenanceTab: 'Smart Maintenance Application',
    comingSoonTab: 'Coming Soon',
    nestAuraDesc: 'NestAura is a concept-driven product designed to enhance and streamline client presentations for real estate firms.It enables businesses to showcase properties with clarity, consistency, and visual impact, helping clients better understand offerings and make informed decisions.By improving engagement and simplifying communication, NestAura elevates the overall client experience and strengthens brand credibility.',
    smartMaintenanceBadge: 'Smart Operations Solution',
    smartMaintenanceTitle: 'Smart Maintenance Application',
    smartMaintenanceDesc: 'Smart Maintenance Application helps teams monitor assets, schedule preventive maintenance, track service activity, and respond faster to issues through one streamlined digital workflow. It is designed to improve visibility, reduce downtime, and keep maintenance operations organized and efficient.',
    smartMaintenancePanelText: 'A centralized maintenance platform for asset tracking, preventive schedules, work updates, and faster issue resolution.',
    comingSoonBadge: 'Innovation in Progress',
    comingSoonTitle: 'A Unique Application Is Coming',
    comingSoonDesc: 'We are coming up with a unique application. Stay tuned for something exciting from HonouredTech.',
    comingSoonPanelText: 'We are coming up with a unique application. Stay tuned.',
    needDemo: 'Need a demo? Contact us',
    
    // Contact Section
    contactUs: 'Contact Us',
    contactDescription: "We'd love to hear from you! Reach out to us through any of the following channels.",
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    needQuickAssistance: 'Need Quick Assistance?',
    whatsappText: 'Chat with us now',
    chatOnWhatsapp: 'Chat on WhatsApp',
    
    // Footer
    footerDescription: "Building Tomorrow's Technology Today. Your trusted partner in digital transformation and innovation.",
    quickLinks: 'Quick Links',
    contact: 'Contact',
    allRightsReserved: 'All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service'
  },
  ar: {
    // Navigation
    home: 'الرئيسية',
    aboutUs: 'من نحن',
    services: 'الخدمات',
    products: 'المنتجات',
    contactUs: 'اتصل بنا',
    
    // Home Section
    welcomeTo: 'مرحباً بكم في',
    honouredTech: 'هونورد تك',
    welcomeSubtitle: 'شريكك التكنولوجي الموثوق',
    welcomeDescription: 'نقدم حلولاً تقنية مبتكرة لمساعدة عملك على النمو والنجاح في العصر الرقمي. مع خبرة متطورة والتزام بالتميز، نقدم نتائج مهمة.',
    
    // About Section
    whoWeAre: 'من نحن',
    buildingTomorrow: 'بناء',
    tomorrows: 'الغد',
    technologyToday: 'تقنية اليوم',
    aboutText1: 'في شركة HonouredTech، لا نكتفي ببناء البرمجيات فحسب، بل نخلق تجارب رقمية ذات مغزى. وبفضل مواردنا التي تتمتع بخبرة تزيد عن عقد من الزمان في تطوير البرمجيات، فإن حلولنا تتشكل من خلال أفكار جديدة ومواهب محلية ماهرة وتفكير إبداعي.',
    aboutText2: 'اسمنا يعكس قيمنا: "التكنولوجيا بشرف". نؤمن بأن البرمجيات يجب أن تكون جذابة وهادفة ومؤثرة. كل مشروع نقدمه مصمم بعناية فائقة ليتميز، ويلهم الحوارات، ويربط الناس من خلال التكنولوجيا.',
    learnOurStory: 'تعرف على قصتنا',
    foundedWithVision: 'تأسست برؤية',
    youngAndGrowing: 'نحن شباب وفي نمو مستمر',
    
    // Partnership Section
    greatIdea: 'لديك فكرة رائعة ولكن غير متأكد من كيفية تنفيذها؟',
    partnerText: 'شارك مع',
    visionText: 'ودعنا نحول رؤيتك إلى منتج ناجح',
    lets: 'دعونا',
    riseTogether: 'نرتقي معاً',
    innovateTogether: 'نبتكر معاً',
    growTogether: 'ننمو معاً',
    startBuilding: 'لنبدأ البناء',
    
    // Services Section
    ourServices: 'خدماتنا',
    servicesDescription: 'نقدم مجموعة شاملة من الخدمات التقنية لتلبية احتياجات عملك.',
    webDevelopment: 'تطوير الويب',
    webDevDesc: 'تطبيقات ويب مخصصة مبنية بأحدث التقنيات وأفضل الممارسات.',
    mobileApps: 'تطبيقات الجوال',
    mobileAppsDesc: 'تطبيقات جوال أصلية ومتعددة المنصات لنظامي iOS و Android.',
    digitalMarketing: 'التسويق الرقمي',
    digitalMarketingDesc: 'حلول تسويق رقمي استراتيجية لتنمية علامتك التجارية والوصول إلى جمهورك المستهدف.',
    productDevelopment:"تطوير المنتجات",
    productDevelopmentDesc:"من الفكرة إلى الإطلاق، نساعدك في جلب منتجاتك إلى السوق بسهولة.",
    // Products Section
    ourProducts: 'منتجاتنا',
    productsDescription: 'اكتشف حلولنا المبتكرة المصممة لتحويل عملك.',
    recentlyLaunched: 'تم إطلاقه مؤخراً',
    nestAuraTab: 'مشروع نيست أورا',
    smartMaintenanceTab: 'تطبيق الصيانة الذكي',
    comingSoonTab: 'قريباً',
    nestAuraDesc: 'NestAura منتج قائم على مفهوم مبتكر، مصمم لتحسين وتبسيط عروض العملاء لشركات العقارات. فهو يمكّن الشركات من عرض العقارات بوضوح واتساق وتأثير بصري قوي، مما يساعد العملاء على فهم العروض بشكل أفضل واتخاذ قرارات مدروسة. ومن خلال تحسين التفاعل وتبسيط التواصل، يرتقي NestAura بتجربة العميل الشاملة ويعزز مصداقية العلامة التجارية.',
    smartMaintenanceBadge: 'حل ذكي لإدارة العمليات',
    smartMaintenanceTitle: 'تطبيق الصيانة الذكي',
    smartMaintenanceDesc: 'يساعد تطبيق الصيانة الذكي الفرق على متابعة الأصول، وجدولة الصيانة الوقائية، وتتبع أعمال الخدمة، والاستجابة للمشكلات بسرعة أكبر من خلال سير عمل رقمي موحد. وقد صُمم لتحسين الرؤية وتقليل التوقفات والحفاظ على تنظيم وكفاءة عمليات الصيانة.',
    smartMaintenancePanelText: 'منصة مركزية لإدارة الصيانة تشمل تتبع الأصول، والجداول الوقائية، وتحديثات العمل، وتسريع معالجة الأعطال.',
    comingSoonBadge: 'ابتكار قيد التطوير',
    comingSoonTitle: 'تطبيق فريد قادم قريباً',
    comingSoonDesc: 'نعمل حالياً على تطوير تطبيق فريد من نوعه. ترقبوا المزيد من HonouredTech.',
    comingSoonPanelText: 'نحن بصدد إطلاق تطبيق فريد من نوعه، ترقبوا ذلك.',
    needDemo: 'تحتاج عرض توضيحي؟ اتصل بنا',
    
    // Contact Section
    contactUs: 'اتصل بنا',
    contactDescription: 'يسعدنا سماع رأيك! تواصل معنا من خلال أي من القنوات التالية.',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    address: 'العنوان',
    needQuickAssistance: 'تحتاج مساعدة سريعة؟',
    whatsappText: 'تحدث معنا مباشرة على واتساب للحصول على دعم فوري.',
    chatOnWhatsapp: 'الدردشة على واتساب',
    
    // Footer
    footerDescription: 'بناء تقنية الغد اليوم. شريكك الموثوق في التحول الرقمي والابتكار.',
    quickLinks: 'روابط سريعة',
    contact: 'اتصل',
    allRightsReserved: 'جميع الحقوق محفوظة.',
    privacyPolicy: 'سياسة الخصوصية',
    termsOfService: 'شروط الخدمة'
  }
};
